import { render, staticRenderFns } from "./ViewKeywords.vue?vue&type=template&id=474986a0&scoped=true&"
import script from "./ViewKeywords.vue?vue&type=script&lang=js&"
export * from "./ViewKeywords.vue?vue&type=script&lang=js&"
import style0 from "./ViewKeywords.vue?vue&type=style&index=0&id=474986a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474986a0",
  null
  
)

export default component.exports